import dayjs from 'dayjs';

const hasUsableBirthday = (
  birthday: Date | string | null | undefined
): birthday is Date | string => {
  if (birthday == null || birthday === '') return false;

  return dayjs(birthday).isValid();
};

/**
 * Fail-open adult check for analytics SDKs.
 *
 * Returns false only when:
 * - birthday is a valid date and the person is under 18, or
 * - birthday is missing/invalid and `isMinor` is explicitly `true`.
 *
 * Missing birthday with missing/`false` `isMinor` returns true (allow recording).
 */
export function isAdultFromBirthday(
  birthday: Date | string | null | undefined,
  isMinor?: boolean | null
): boolean {
  if (hasUsableBirthday(birthday)) {
    return dayjs().diff(dayjs(birthday), 'year') >= 18;
  }

  if (isMinor === true) {
    return false;
  }

  return true;
}
